<template>
  <div class="chat-header" :style="{ 'box-shadow': boxShadow }">
    <div
      class="chat-header-title flex items-center"
    >
      <div>
        <button
          v-if="!isShowingOpenChat"
          id="restartButton"
          type="button"
          class="button button-nothing button-pressed"
          :aria-label="$t('chatbot.restart')"
          @click="onRestart"
        >
          <svg class="chat-header-restart-button-svg"
               viewBox="0 0 20 20"
               width="12"
               fill="currentColor"
               stroke="currentColor"
               aria-labelledby="restartButton"
          >
            <use
              xlink:href="#icon-repeat"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            />
          </svg>
        </button>
      </div>
      <div class="flex-center">
        <customer-avatar class="is-big" />
        <span class="chat-header-customer-name" :style="{'font-family': fontFamily}">{{ headerTitle }}</span>
        <img
          v-if="logoUrl"
          class="chat-header-logo"
          :src="logoUrl"
          alt=""
        >
      </div>
      <div>
        <button
          v-if="showCloseButton"
          id="closeButton"
          type="button"
          class="button button-nothing close-button"
          :aria-label="$t('chatbot.close')"
          @click="$emit('close')"
        >
          <svg class="chat-header-close-button-svg"
               viewBox="0 0 20 20"
               width="12"
               fill="currentColor"
               stroke="currentColor"
               aria-labelledby="closeButton"
          >
            <use
              xlink:href="#icon-close"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            />
          </svg>
        </button>
      </div>
    </div>
    <div
      v-if="headerDescription && !isShowingOpenChat"
      class="chat-header-description flex-center">
      <div class="chat-header-description__content">{{ headerDescription }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CustomerAvatar from '../CustomerAvatar/CustomerAvatar.vue'
import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../../main/eventTracking'

import { restartMixin } from '../../mixins'

export default {
  components: {
    CustomerAvatar
  },
  mixins: [restartMixin],
  props: {
    showCloseButton: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['headerTitle', 'headerFont', 'logoUrl', 'headerDescription', 'showProgressBar', 'isShowingOpenChat', 'chatbotId']),
    ...mapState(['customerId', 'subscriberId', 'welcomeMessage', 'parentUrl']),
    fontFamily () {
      return this.headerFont
    },
    boxShadow () {
      if (this.showProgressBar) return ''

      return '0 3px 5px #77777785'
    }
  },
  methods: {
    onRestart () {
      this.handleRestart()
      dispatchChatchampEvent(CHATBOT_EVENTS.Restarted, {
        customerId: this.customerId,
        subscriberId: this.subscriberId,
        chatbotId: this.chatbotId,
        parentUrl: this.parentUrl
      })
    }
  }
}
</script>

<style src="./chat-header.scss"></style>
